var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin (2) 1",
    clipPath: "url(#clip0_367_30649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 23.9998C18.6274 23.9998 24 18.6272 24 11.9998C24 5.37234 18.6274 -0.000244141 12 -0.000244141C5.37258 -0.000244141 0 5.37234 0 11.9998C0 18.6272 5.37258 23.9998 12 23.9998Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1698 12.9653V17.9127H16.3014V13.2969C16.3014 12.1379 15.8873 11.3465 14.8488 11.3465C14.0562 11.3465 13.5854 11.8793 13.3775 12.3953C13.302 12.5797 13.2825 12.8357 13.2825 13.0943V17.9125H10.4139C10.4139 17.9125 10.4525 10.0949 10.4139 9.28563H13.2827V10.5081C13.2769 10.5178 13.2688 10.5272 13.2637 10.5364H13.2827V10.5081C13.6639 9.92159 14.3437 9.08306 15.8678 9.08306C17.755 9.08306 19.1698 10.316 19.1698 12.9653ZM7.4132 5.1272C6.43199 5.1272 5.79004 5.77128 5.79004 6.61752C5.79004 7.44578 6.41338 8.10848 7.37555 8.10848H7.39416C8.39462 8.10848 9.01668 7.44578 9.01668 6.61752C8.99764 5.77128 8.39462 5.1272 7.4132 5.1272ZM5.96053 17.9127H8.82801V9.28563H5.96053V17.9127Z",
    fill: "#F1F2F2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_30649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShare);
export default __webpack_public_path__ + "static/media/linkedinShare.0bdcc6d2fe0bf370dc323ad94cb4a76b.svg";
export { ForwardRef as ReactComponent };